import { render } from "./Lightbox.vue?vue&type=template&id=a99b2c40&scoped=true"
import script from "./Lightbox.vue?vue&type=script&lang=js"
export * from "./Lightbox.vue?vue&type=script&lang=js"

import "./Lightbox.vue?vue&type=style&index=0&id=a99b2c40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a99b2c40"]])

export default __exports__